












import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'

settings =
  name: 'NoActivationDatesDisplay'

  vue:
    props: ['item', 'options']

    computed:
      segment: -> @item.segment || @options?.segment || @selectedSegment || @lineItem.segment
      segmentsList: -> @options?.segmentsList || []
      displaySegmentsList: -> @segmentsList.length > 1

      selectedSegment:
        get: -> @$route.query.segment
        set: (segment) -> @$router.replace { query: { ...@$route.query, segment } }

export default VueOptions.vue settings
